import * as React from "react";
import classNames from "classnames";
import "./SPOTInput.scss";
import { Translation, useTranslation } from "react-i18next";
import { FieldValues, UseFormRegister, ValidationRule } from "react-hook-form";
import { FieldErrors, Message } from "react-hook-form/dist/types/errors";
import "../../../resources/icons/style.css";
import ToolTip from "../../basic/tooltip/ToolTip";

export interface FormFieldProps {
    id?: string;
    name: string;
    label?: string;
    type?: string;
    className?: string;
    placeholder?: string;
    defaultValue?: any;
    dataId?: any;
    errors?: FieldErrors;
    register: UseFormRegister<FieldValues>;
    isTouched?: boolean;
    disabled?: boolean;
    onChange: any;
    onBlur?: any;
    required?: Message | ValidationRule<boolean>;
    pattern?: ValidationRule<RegExp>;
    min?: ValidationRule<number | string>;
    max?: ValidationRule<number | string>;
    maxLength?: number;
    minLength?: number;
    autofocus?: boolean;
    computedValidation?: any;
    modal?: string;
}

export const SPOTInput = React.forwardRef((props: FormFieldProps, ref: any) => {
    const { t } = useTranslation();
    const [touched, setTouched] = React.useState(props.isTouched);
    const error = props.errors && props.errors[props.name];
    const register = props.register as UseFormRegister<FieldValues>;

    const marksTouched = () => {
        setTouched(true);
    };

    const computedValidation = async (value: any) => {
        if (props.computedValidation) {
            return await props.computedValidation(value);
        } else {
            return true;
        }
    };

    return (
        <div>
            <div className={"input-label-wrapper"}>
                {props.label && (
                    <label className={"input-label"} htmlFor={props.id}>
                        <Translation>{(t, { i18n }) => <b>{t(props.label as string)}</b>}</Translation>
                    </label>
                )}
                {props.modal && <ToolTip iconSize={23} position={"top center"} text={props.modal} />}
            </div>

            <div
                className={classNames({
                    "input-field": true,
                    "input-success": props.defaultValue && touched && !error,
                    "input-error": error
                })}>
                <input
                    type={props.type ? props.type : "text"}
                    className={props.className}
                    data-id={props.dataId}
                    maxLength={props.maxLength}
                    id={props.id}
                    disabled={props.disabled}
                    {...register(props.name as string, {
                        required: props.required,
                        pattern: props.pattern,
                        min: props.min,
                        max: props.max,
                        validate: computedValidation,
                        onChange: (e: any) => {
                            props.onChange(e);
                        },
                        onBlur: (e: any) => {
                            marksTouched();
                            if (props.onBlur) {
                                props.onBlur(e);
                            }
                        }
                    })}
                    placeholder={t(props.placeholder as string)}
                    defaultValue={props.defaultValue}
                    autoFocus={props.autofocus}
                />
                {props.defaultValue && touched && !error && <i className="icon-checkmark input-icon" />}
                {error && <i className={"icon-close input-icon"} />}
                <span className={"inputErrorMessage"}>{error && error.message}</span>
            </div>
        </div>
    );
});
